<div
  class="installation-type-container flex flex-row lt-md:flex-col lt-md:gap-[16px] gap-[24px] justify-start lt-lg:justify-between items-center"
>
  <div
    class="installation-type-box flex flex-row lt-lg:flex-col justify-start items-center lt-lg:items-start"
    data-at-commissioning-type="residential"
  >
    <img
      class="lt-md:!hidden"
      src="assets/img/gateway-commissioning/installation-type-residential.svg"
    />
    <div class="details">
      <div class="title">
        {{ '+GATEWAY_COMMISSIONING.INSTALLATION_TYPE.RESIDENTIAL.TITLE' | translate }}
      </div>

      <div class="flex flex-col justify-start items-start">
        <div
          class="link flex flex-row justify-start items-center"
          data-at-device-type="vitoconnect"
          gtm="onSelect"
          gtmAction="Commissioning Vitoconnect - Residential"
          gtmCategory="gatewayCommissioning"
          (click)="nextStepClicked(deviceType.VITOCONNECT, commissioningFlow.RESIDENTIAL)"
        >
          <span
            >{{ '+GATEWAY_COMMISSIONING.COMMISSIONING_OF_VITOCONNECT' | translate }}
            <mat-icon class="arrow-icon">chevron_right</mat-icon></span
          >
        </div>
        <div
          class="link flex flex-row justify-start items-center"
          data-at-device-type="oneBase"
          gtm="onSelect"
          gtmAction="Commissioning One-base - Residential"
          gtmCategory="gatewayCommissioning"
          (click)="nextStepClicked(deviceType.ONE_BASE, commissioningFlow.RESIDENTIAL)"
        >
          <span
            >{{ '+GATEWAY_COMMISSIONING.COMMISSIONING_OF_ONE_BASE' | translate }}
            <mat-icon class="arrow-icon">chevron_right</mat-icon></span
          >
        </div>
      </div>
    </div>
  </div>

  <div
    class="installation-type-box flex flex-row lt-lg:flex-col justify-start items-center lt-lg:items-start"
    data-at-commissioning-type="commercial"
  >
    <img
      class="lt-md:!hidden"
      src="assets/img/gateway-commissioning/installation-type-commercial.svg"
    />
    <div class="details">
      <div class="title">
        {{ '+GATEWAY_COMMISSIONING.INSTALLATION_TYPE.COMMERCIAL.TITLE' | translate }}
      </div>

      <div class="flex flex-col justify-start items-start">
        <div
          class="link flex flex-row justify-start items-center"
          data-at-device-type="vitoconnect"
          gtm="onSelect"
          gtmAction="Commissioning Vitoconnect - Commercial"
          gtmCategory="gatewayCommissioning"
          (click)="nextStepClicked(deviceType.VITOCONNECT, commissioningFlow.COMMERCIAL)"
        >
          <span
            >{{ '+GATEWAY_COMMISSIONING.COMMISSIONING_OF_VITOCONNECT' | translate }}
            <mat-icon class="arrow-icon">chevron_right</mat-icon></span
          >
        </div>
        <div
          class="link flex flex-row justify-start items-center"
          data-at-device-type="oneBase"
          gtm="onSelect"
          gtmAction="Commissioning One-base - Commercial"
          gtmCategory="gatewayCommissioning"
          (click)="nextStepClicked(deviceType.ONE_BASE, commissioningFlow.COMMERCIAL)"
        >
          <span
            >{{ '+GATEWAY_COMMISSIONING.COMMISSIONING_OF_ONE_BASE' | translate }}
            <mat-icon class="arrow-icon">chevron_right</mat-icon></span
          >
        </div>
      </div>
    </div>
  </div>
</div>
